import { useConfigContext } from "@/app";
import { useToggle } from "ahooks";
import { Image, ImageViewer } from "antd-mobile";
import { PropsWithChildren } from "react";
export type ImageViewerLocalProps = PropsWithChildren<{
  className?: string;
  src: string;
  directive?: boolean;
}>;
export const ImageViewerLocal = ({
  src,
  directive
}: ImageViewerLocalProps) => {
  const [visible, {
    toggle: toggleVisible
  }] = useToggle();
  const {
    getSourcePath
  } = useConfigContext();
  return <>
      <Image src={src && getSourcePath(src)} onClick={() => {
      toggleVisible();
      if (directive && src) {
        ImageViewer.show({
          image: getSourcePath(src)
        });
      }
    }} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      {src && !directive && <ImageViewer image={getSourcePath(src)} visible={visible} onClose={toggleVisible} />}
    </>;
};